module.exports = __webpack_public_path__ + "media/images/example-check-d5fa6670.png";